<div class="sx-help">
  <div class="sx-help__header">
    <button class="sx-help__header__close sx-button sx-button--white sx-button--exit" mat-button (click)="onClose()">
      <svg>
        <use xlink:href="#baseline-close-24px" href="#baseline-close-24px" />
      </svg>
    </button>
    <div class="sx-help__header__title">
      {{ title }}
    </div>
  </div>

  <div class="sx-help__content">
    <div *ngIf="(isHelpLoading$ | async) === false && (currentHelpState$ | async) === helpStateEnum.contextualInfo && (helpData$ | async)">
      <app-help-contextual-info 
        [contextualInfoData]="(helpData$  |async).contextualInfo" 
        [currentContextualInfoData]="(currentHelpContextualInfo$  |async)">
      </app-help-contextual-info>
    </div>

    <div *ngIf="(isHelpLoading$ | async) === false && (currentHelpState$ | async) === helpStateEnum.glossary && (helpData$ | async)">
      <app-help-glossary [glossaryData]="(helpData$ | async).glossary"></app-help-glossary>
    </div>

    <div *ngIf="(isHelpLoading$ | async) === false && (areGuidesLoading$ | async) === false && (currentHelpState$ | async) === helpStateEnum.introduction && (helpData$ | async)">
      <app-help-introduction [introductionData]="(helpData$ | async).introduction" [guides]="(guides$ | async)"></app-help-introduction>
    </div>

    <div *ngIf="(isHelpLoading$ | async) === false && (currentHelpState$ | async) === helpStateEnum.support && (helpData$ | async)">
      <app-help-support [supportData]="(helpData$ | async).support"></app-help-support>
    </div>

    <div *ngIf="(isHelpLoading$|async) === true || ((currentHelpState$ | async) === helpStateEnum.introduction) && (areGuidesLoading$ | async) === true">
      <app-spinner></app-spinner>
    </div>
  </div>
</div>